import { TFunction } from 'i18next';

import { dateService } from 'shared/lib/date';

export const getLocationFormattedDate = (
  locationTimestamp: number,
  t: TFunction<'translation', undefined>,
) => {
  const todayTimestamp = dateService.getDayJSObject().valueOf();

  const timeDiffMilliseconds = Math.abs(todayTimestamp - locationTimestamp);
  const timeDiffSeconds = Math.floor(timeDiffMilliseconds / 1000);
  const timeDiffMinutes = Math.floor(timeDiffSeconds / 60);
  const timeDiffHours = Math.floor(timeDiffMinutes / 60);
  const timeDiffDays = Math.floor(timeDiffHours / 24);

  if (timeDiffMinutes < 1) {
    return t('a few seconds ago');
  }

  if (timeDiffHours < 1) {
    return `${timeDiffMinutes}${t('m Ago')}`;
  }

  if (timeDiffHours < 24) {
    return `${timeDiffHours}${t('h Ago')}`;
  }
  return `${timeDiffDays}${t('d Ago')}`;
};

export const getLocationDateISOString = (locationTimestamp: number) => {
  const locationDate = dateService.getDayJSObject(locationTimestamp);
  return locationDate.toISOString();
};

export const getLocationDateUpdateInterval = (locationTimestamp: number) => {
  const todayTimestamp = dateService.getDayJSObject().valueOf();

  const timeDiffMilliseconds = Math.abs(todayTimestamp - locationTimestamp);
  const ONE_MINUTE_MS = 60 * 1000;
  const ONE_HOUR_MS = ONE_MINUTE_MS * 60;
  const timeDiffHours = Math.floor(timeDiffMilliseconds / ONE_HOUR_MS);

  if (timeDiffHours < 1) {
    return ONE_MINUTE_MS;
  }

  return ONE_HOUR_MS;
};
